import { AGREEMENT_LABELS, type AgreementKey } from '@musinsa/services-curator';
import { useCallback, useState } from 'react';

export const useAgreementState = () => {
  const agreementKeys = Object.keys(AGREEMENT_LABELS) as AgreementKey[];
  const [agreements, setAgreements] = useState<Record<AgreementKey, boolean>>(() =>
    agreementKeys.reduce(
      (acc, key) => ({ ...acc, [key]: false }),
      {} as Record<AgreementKey, boolean>,
    ),
  );

  const toggleAgreement = useCallback(
    (type: AgreementKey | 'all') => {
      if (type === 'all') {
        const allAgreed = agreementKeys.every((key) => agreements[key]);
        const newState = agreementKeys.reduce(
          (acc, key) => ({ ...acc, [key]: !allAgreed }),
          {} as Record<AgreementKey, boolean>,
        );
        setAgreements(newState);
      } else {
        setAgreements((prev) => ({
          ...prev,
          [type]: !prev[type],
        }));
      }
    },
    [agreements, agreementKeys],
  );

  const isAllAgreed = agreementKeys.every((key) => agreements[key]);
  const isFormValid = isAllAgreed;

  return {
    agreements,
    toggleAgreement,
    isAllAgreed,
    isFormValid,
  };
};
